module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsSAAALEgHS3X78AAABDklEQVQ4y6WTzXGDMBCFPzQUQAl0gDsw6YDLnqEEl5ISxHkvdBDTgemAEuiAXB4emSF2nLwZzWhX+yM9vc3WdSWFu3dAB5x5xAhEM4upM9sKuHsJDEAF9NoviiuABmiBCWjMbL4XUPINmIHOzG4cwN1PQARK4GRmc9DZoOQ6TXb32t3rzdZZrdgBIOjNlTovu6ZfWiRFFnFUuXsXZPQ/XfsIiu2BLojtgfcxAOdcxpKQ9HlA3jUxL7rBApDvYouD/2fnK9Kmeeo0syuQJZ1XYDSz+qBoCRCksOYPHDTAGCSMVu//FSS8FohB2p6A6O7FLvYDuOySC/3AZGbxXSlv83KX8qthmkXw82H6zzh/A/GFih1VkMQ+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Plus.png
// module id = 185
// module chunks = 0 1